import { LAYOUTS, MODULE_SETTINGS, OVERVIEW_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";

/**
 * Portfolio route fragment for /overview/portfolios
 * Import and spread into overviewRoutes.js children array.
 */
export const overviewPortfolioFragment: AppRouteRecordRaw[] = [
  {
    path: "portfolios",
    name: "overviewPortfolios",
    component: () => import("portfolio/pages/OverviewPortfoliosPage.vue"),
    meta: {
      title: "Portfolio",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [MODULE_SETTINGS.PORTFOLIO],
      roleRequired: OVERVIEW_ROLES,
      layout: LAYOUTS.MAIN_NO_WRAPPER,
    },
  },
];
